import React from 'react'
import { CircleSpinner } from 'react-spinner-overlay';
import MyButton from '../../UI/button/MyButton';
import MyInput from '../../UI/input/MyInput';
import MySelect from '../../UI/select/MySelect';
import NumericInput from '../NumericInput';

export default function WizardForm({
    obligationSource,
    setObligationSource,
    obligationType,
    setObligationType,
    paymentNature,
    setPaymentNature,
    nonExecutionType,
    setNonExecutionType,
    hasPenaltyClause,
    setHasPenaltyClause,
    penaltyPercent,
    setPenaltyPercent,
    gracePeriodDays,
    setGracePeriodDays,
    onSubmit,
    loading
  }){

    const isFormValid =
  obligationSource &&
  (
    obligationSource !== "contract" ||
    (
      obligationType &&
      (
        (obligationType === "payment" && paymentNature) ||
        (obligationType === "delivery" && nonExecutionType) ||
        obligationType === "other"
      )
    )
  ) &&
  (
    !hasPenaltyClause ||
    (penaltyPercent && gracePeriodDays)
  );

    return (
        <form className='form-container'>
        <div className="myInpWrapper">
          <label>Sursa obligației:</label>
          <MySelect
            options={[
              { value: "contract", label: "Contract/Înțelegere" },
              { value: "delict", label: "Faptă ilicită" },
              { value: "unjust", label: "Plată din eroare" },
              { value: "other", label: "Altele" },
            ]}
            onChange={(val) =>{setObligationSource(val);setObligationType(""); setPaymentNature(""); setNonExecutionType("");}}
          />
        </div>
      
        {obligationSource === "contract" && (
          <div className="myInpWrapper">
            <label>Tip obligație contractuală:</label>
            <MySelect
              options={[
                { value: "payment", label: "Plată bani" },
                { value: "delivery", label: "Predare bun/serviciu" },
                { value: "other", label: "Altă obligație" },
              ]}
              onChange={(val) => {setObligationType(val); setPaymentNature(""); setNonExecutionType("");}}
            />
          </div>
        )}
      
        {obligationType === "payment" && (
          <div className="myInpWrapper">
            <label>Natura plății:</label>
            <MySelect
              options={[
                { value: "goods", label: "Preț bun/serviciu" },
                { value: "rent", label: "Chirie/Leasing" },
                { value: "loan", label: "Împrumut" },
              ]}
              onChange={(val) => setPaymentNature(val)}
            />
          </div>
        )}
      
        {obligationType === "delivery" && (
          <div className="myInpWrapper">
            <label>Tip neexecutare:</label>
            <MySelect
              options={[
                { value: "total", label: "Totală" },
                { value: "partial", label: "Parțială" },
                { value: "delay", label: "Cu întârziere" },
              ]}
              onChange={(val) => setNonExecutionType(val)}
            />
          </div>
        )}
      
        <div className="myInpWrapper">
          <MyInput
            name="terms-check"
            type="checkbox"
            checked={hasPenaltyClause}
            onChange={(e) => setHasPenaltyClause(e.target.checked)}
            label="Clauză penală:"
          />
        </div>
      
        {hasPenaltyClause && (
          <>
            <div className="myInpWrapper">
              <label htmlFor="penaltyPercent">Procent penalitate (%/zi):</label>
              <NumericInput
                name="penaltyPercent"
                value={penaltyPercent || ""}
                onChange={(e) => setPenaltyPercent(e.target.value)}
                allowDecimals={true}
                placeholder="Ex: 0.5"
              />
            </div>
      
            <div className="myInpWrapper">
              <label htmlFor="gracePeriodDays">Perioadă de grație (zile):</label>
              <NumericInput
                name="gracePeriodDays"
                value={gracePeriodDays || ""}
                onChange={(e) => setGracePeriodDays(e.target.value)}
                allowDecimals={false}
                placeholder="Ex: 15"
              />
            </div>
          </>
        )}
      
        <div style={{ marginTop: "1rem" }}>
          <MyButton
            body={loading ? <CircleSpinner loading={loading}/>:"Finalizează Pretenția"}
            onClick={onSubmit}
            disabled={!isFormValid || loading}
          />
        </div>
      </form>      
      );
    }
